<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :onClose="onClose">
    <div class="row" v-if="content === 'content1'">
      <div class="col-12 col-lg-12">
        En Rentik hemos recibido, firmado y debidamente cumplimentado la autorización de adeudos SEPA.
      </div>
      <div class="col-12 col-lg-12">
        <div class="form-group">
          <label class="generalLabel" for="signatureDate">Fecha firma SEPA</label>
          <DatePicker v-model="signatureDate" mode="date" :model-config="modelConfig">
            <template v-slot="{ togglePopover }">
              <input
                @click="togglePopover()"
                class="form-control bg-white generalInput"
                readonly
                v-model="signatureDate"
              />
              <v-icon
                name="ri-calendar-line"
                scale="0.9"
                class="generalSelect__iconDate"
                @click="togglePopover()"
              />
            </template>
          </DatePicker>
        </div>
      </div>
      <div class="col-12 col-lg-12">
        <label class="generalLabel" for="ibanCheck">Introducir IBAN: </label>
        <input type="text" class="form-control generalInput  mb-3" id="ibanCheck" v-model.trim.lazy="v$.confirmIBAN.$model">
      </div>
      <div class="col-12 col-lg-12">
        <button class="btn btn-primary generalPrimaryButton float-right" style="margin-bottom: 120px;"
          @click="accept()" v-bind:class="{ disabled: v$.$invalid }" :disabled="v$.$invalid || loading">
          <img v-if="loading" src="../../../../../assets/loader.svg" height="20" alt="">
          <span v-else>Confirmar</span>
        </button>
      </div>
    </div>
    <template v-if="content === 'content2'">
      <div class="row mt-3">
        <div class="col-12">
          <p>{{ message }}</p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="h-100 d-flex justify-content-end">
            <div>
              <button class="btn btn-primary generalPrimaryButton" @click="onClose()">
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <button :id="id+'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
</template>
<script>

import Modal from '../../../Shared/Modal.vue';
import axios from 'axios';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { DatePicker } from "v-calendar";

const validateIBAN = (value) => {
  if (value != '' && value != undefined) {
    var CODE_LENGTHS = {
      AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
      CH: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24, XK: 20,
      FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
      HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
      LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
      MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
      RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26,
      AL: 28, BY: 28, CR: 22, EG: 29, GE: 22, IQ: 23, LC: 32, SC: 31, ST: 25,
      SV: 28, TL: 23, UA: 29, VA: 22, VG: 24 
    };
    var iban = String(value).toUpperCase().replace(/[^A-Z0-9]/g, ''),
      code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/)
    // check syntax and length
    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return false;
    }
    // rearrange country code and check digits, and convert chars to ints
    var digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
      return letter.charCodeAt(0) - 55;
    });

    var checksum = digits.slice(0, 2), fragment;
    for (var offset = 2; offset < digits.length; offset += 7) {
      fragment = String(checksum) + digits.substring(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
    }
    return checksum;
  }
  else {
    return false
  }
}

export default {
  name: 'ConfirmPayment',
  setup() {
    return { v$: useVuelidate() }
  },
  props: [
    'id',
    'modalTitle',
    'class',
    'contractId',
    'contractIndex'
  ],
  data() {
    return {
      classes: this.class,
      confirmIBAN: '',
      signatureDate: '',
      modelConfig: {
        type: "string",
        mask: "DD/MM/YYYY",
      },
      content:'content1',
      loading: false,
      message: '',
    }
  },
  validations() {
    return {
      confirmIBAN: {
        validateIBAN,
      },
      signatureDate: {
        required,
      },
    }
  },
  components: {
    Modal,
    DatePicker,
  },
  methods: {
    accept() {
      this.loading = true;
      let bodyToSend = {
        businessContractId: this.contractId,
        status: 'payment_received',
        paymentData: {
          iban: this.confirmIBAN,
          signatureDate: this.$dateFrontToBack(this.signatureDate),
        }
      }
      axios.patch(`/business/update-contract`, bodyToSend)
        .then(() => {
          let bodyStatus = {
            "contractIndex": this.contractIndex,
            "cancellation": bodyToSend.status,
            "description": 'PAGO RECIBIDO'
          }
          this.loading = false;
          this.message = 'Gestión realizada correctamente.';
          this.selectTab("content2");
          this.$emit("refreshContractList", bodyStatus);
        })
        .catch(() => {
          this.loading = false;
          this.message = 'Ha ocurrido un error, inténtelo de nuevo mas tarde.';
          this.selectTab("content2");
        });
    },
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", '');
		},
    selectTab(id) {
      this.content = id;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
